import React from "react";
import { Icon } from "@iconify/react";
import { Button } from "react-bootstrap";
import SelectDropdowns from "./Selectdropdown";

const DIMENSION_OPTIONS = [
  { value: 0, label: "Millimeters" },
  { value: 1, label: "Inches" },
];

const INSUNITS_ERROR_TITLE = "Missing unit information";
const INSUNITS_ERROR_SUBTITLE = "Select the measurement units for each file below.";

const DxfInsunitsWarning = ({
  invalidFileNames,
  dimensionTypeByFile,
  onDimensionSelect,
  onFixFiles,
  processing,
}) => {
  if (invalidFileNames.length === 0) return null;

  return (
    <div className="invalid-dxf-files mb-4">
      <div className="invalid-dxf-files__panel">
        <div className="invalid-dxf-files__header">
          <Icon
            icon="mdi:alert-circle-outline"
            width={20}
            height={20}
            className="invalid-dxf-files__icon"
          />
          <div className="flex-grow-1">
            <span className="text-dark fw-semibold d-block">
              {INSUNITS_ERROR_TITLE}
            </span>
            <span className="text-secondary">
              {INSUNITS_ERROR_SUBTITLE}
            </span>
          </div>
          <Button
            size="sm"
            variant="primary"
            onClick={onFixFiles}
            disabled={processing}
          >
            <Icon icon="mdi:wrench" className="me-1" width={16} height={16} />
            Fix files
          </Button>
        </div>
        <div className="px-2 py-1">
          {invalidFileNames.map(({ id, name }) => (
            <div key={id} className="invalid-dxf-files__row">
              <Icon
                icon="mdi:file-document-outline"
                width={18}
                height={18}
                className="text-secondary flex-shrink-0"
              />
              <span className="text-break flex-grow-1 invalid-dxf-files__filename">
                {name}
              </span>
              <div className="invalid-dxf-files__dropdown">
                <SelectDropdowns
                  options={DIMENSION_OPTIONS}
                  value={dimensionTypeByFile[id] ?? 1}
                  placeholder="Select Units"
                  type="dimensions"
                  id={id}
                  onOptionSelect={(option) =>
                    onDimensionSelect(id, option.value)
                  }
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DxfInsunitsWarning;
